import { render, staticRenderFns } from "./CardDeckFavorites.vue?vue&type=template&id=786b480e&scoped=true"
import script from "./CardDeckFavorites.vue?vue&type=script&lang=js"
export * from "./CardDeckFavorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b480e",
  null
  
)

export default component.exports